<!--jsp设备系统登录界面-->
<template>
  <div class="loginContainer" :style="loginBg">
    <div class="systemChangeArea">
      <img class="nowSystemImg" :src="nowSystemImg" alt="" />
      <div v-for="item in systemList" class="systemButton" @click="jump(item)"></div>
    </div>
    <div class="formContainer">
      <p class="systemName">{{ systemName }}</p>
      <div class="inputContainer">
        <div class="inputContent">
          <img :src="resourcesStore.getResourcesByName('/demoSystem/icon_user_jsp.png')" alt="" /><input type="text"
            v-model="userCode" placeholder="用户名" />
        </div>
        <div class="inputContent">
          <img :src="resourcesStore.getResourcesByName('/demoSystem/icon_lock.png')" alt="" /><input type="password"
            autocomplete="new-password" v-model="password" placeholder="密码" />
        </div>
        <button @click="loginButton">登&nbsp;录</button>
      </div>
      <p class="attentionText">请使用Chrome、火狐、IE11及其他极速浏览器</p>
    </div>
  </div>
</template>

<script>
  export default {
    components: {},
    props: {},
    data () {
      return {
        userCode: undefined,
        password: undefined,
        systemList: [],
        systemAct: -1,
      }
    },
    created () {
      this.systemList=[{
        nameP1: '工业企业能源',
        nameP2: '管理系统',
        ico: '/demoSystem/system1.png',
        icol: '/demoSystem/system1l.png',
        url: ''
      },{
        nameP1: '用电服务',
        nameP2: '管理系统',
        ico: '/demoSystem/system2.png',
        icol: '/demoSystem/system2l.png',
        url: 'http://127.0.0.1:16002'
      },{
        nameP1: '温度在线',
        nameP2: '监测系统',
        ico: '/demoSystem/system6.png',
        icol: '/demoSystem/system6l.png',
        url: 'http://127.0.0.1:19002'
      },{
        nameP1: '温度监控管理',
        nameP2: '监控系统',
        ico: '/demoSystem/system4.png',
        icol: '/demoSystem/system4l.png',
        url: 'http://127.0.0.1:18002'
      },{
        nameP1: '用电抄表',
        nameP2: '管理系统',
        ico: '/demoSystem/system5.png',
        icol: '/demoSystem/system5l.png',
        checked: true, //当前应该选中的系统
        url: ''
      },{
        nameP1: '光伏电站',
        nameP2: '监控系统',
        ico: '/demoSystem/system3.png',
        icol: '/demoSystem/system3l.png',
        url: ''
      }]
      this.systemAct=this.systemList.findIndex(item => item.checked==true)
    },
    mounted () {
    },
    destroyed () {},
    computed: {
      resourcesStore () {
        return this.$store.resourcesStore.getters
      },
      loginBg () {
        return this.resourcesStore.getBackgroudImageStyle('/demoSystem/background_jsp.jpg')
      },
      nowSystemImg () {
        var src=this.systemList[this.systemAct].systemImg
        return this.resourcesStore.getResourcesByName(src)
      },
      systemName () {
        return this.systemList[this.systemAct].nameP1+this.systemList[this.systemAct].nameP2
      }
    },
    watch: {},
    methods: {
      jump (item) {
        if(isempty(item.url)) {
          this.$dialogMethod.showMessage('网站未开放!')
          return
        }
        window.location.href=item.url
      },
      loginButton () {
        this.$api.userApi.login(this.userCode,hex_md5(this.password),"Web",null,respon => {
          localStorage.setItem('nowWedoSystemUserCode',this.userCode)
          //获取用户信息
          this.$store.userStore.commit("setNowUserCode",this.userCode)
          //获取用户单位信息
          this.$store.unitStore.commit("getUnitTree")
          this.$dialogMethod.showMessage('登录成功，正在跳转。。。')
          setTimeout(() => {
            //获取菜单并且进入主界面
            this.$store.menuStore.commit("getMenuList")
          },1000)
          //连接新后台
          this.$wedoWebSocketClient.connect(respon.webSocketUrl,respon.pkid)
        },respon => {
          this.$dialogMethod.showMessage(respon)
        })
      },
    }
  }
</script>

<style scoped>
  .loginContainer {
    height: 100%;
    overflow: hidden;
    position: relative;
  }

  .systemChangeArea {
    position: absolute;
    z-index: 1;
    top: 50px;
    left: 350px;
    width: 720px;
    cursor: default;
  }

  .nowSystemImg {
    transform: scale(0.8);
  }

  .systemButton {
    position: absolute;
    z-index: 2;
    cursor: pointer;
    border-radius: 50%;
    width: 120px;
    height: 120px;
  }

  .systemButton:nth-of-type(1) {
    top: 128px;
    left: 464px;
  }

  .systemButton:nth-of-type(2) {
    top: 134px;
    left: 345px;
  }

  .systemButton:nth-of-type(3) {
    top: 188px;
    left: 240px;
  }

  .systemButton:nth-of-type(4) {
    top: 272px;
    left: 160px;
  }

  .systemButton:nth-of-type(5) {
    top: 388px;
    left: 135px;
  }

  .systemButton:nth-of-type(6) {
    top: 505px;
    left: 160px;
  }

  .systemButton:nth-of-type(7) {
    top: 596px;
    left: 236px;
  }

  .systemButton:nth-of-type(8) {
    top: 645px;
    left: 343px;
  }

  .systemButton:nth-of-type(9) {
    top: 647px;
    left: 460px;
  }

  .systemButton:nth-of-type(10) {
    top: 295px;
    left: 504px;
  }

  .systemButton:nth-of-type(11) {
    top: 252px;
    left: 388px;
  }

  .systemButton:nth-of-type(12) {
    top: 324px;
    left: 272px;
  }

  .systemButton:nth-of-type(13) {
    top: 457px;
    left: 272px;
  }

  .systemButton:nth-of-type(14) {
    top: 530px;
    left: 380px;
  }

  .systemButton:nth-of-type(15) {
    top: 493px;
    left: 504px;
  }

  .formContainer {
    position: absolute;
    width: 300px;
    top: 340px;
    left: 1020px;
    background-color: #FFFFFF;
    z-index: 10;
  }

  .systemName {
    background-color: #4F94CF;
    color: #FFFFFF;
    line-height: 40px;
    text-align: center;
    font-size: 18px;
  }

  .inputContainer {
    padding: 10px 35px 0 35px;
  }

  .inputContent {
    display: flex;
    margin-top: 20px;
  }

  .inputContent>input {
    flex-grow: 1;
  }

  .inputContainer>button {
    width: 100%;
    background-color: #4F94CF;
    margin-top: 30px;
    height: 35px;
    color: #FFFFFF;
    border-radius: 4px;
    cursor: pointer;
  }

  .attentionText {
    color: #0000FF;
    font-size: 12px;
    text-align: center;
    margin: 20px 0;
  }
</style>